import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Routes from './router/routes';

export default function App() {
  const navigate = useNavigate();
  const token = Cookies.get('admin_token');

  useEffect(() => {
    if (token) {
      navigate(Routes.super_admin_dashboard.path);
    } else {
      navigate(Routes.login.path);
    }
  }, [navigate, token]);

  return null;
}
